<script setup lang="ts">
import QRCode from 'qrcode';
import ScBtn from '@/components/common/widget/ScBtn.vue';
import { ref, watch } from 'vue';

const props = defineProps<{ url: string }>();

const qr = ref();

watch(
  [qr, props],
  () => {
    if (qr.value && props.url) {
      QRCode.toCanvas(qr.value, props.url, {
        width: 300,
        height: 300,
        margin: 4,
      });
    }
  },
  { immediate: true }
);
</script>

<template>
  <div
    style="
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 20px;
    "
  >
    <div style="margin-bottom: 30px">请打开手机支付宝扫码支付</div>
    <div
      style="width: 300px; height: 300px; background: #999; margin-bottom: 30px"
    >
      <canvas ref="qr" />
    </div>
    <sc-btn text="我已完成支付" type="primary" />
  </div>
</template>

<style scoped lang="scss">
.space-between {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.line {
  margin-bottom: 10px;

  &:last-child {
    margin-bottom: 0;
  }
}

.desc {
}
</style>
